import { RydeUiUnit } from "../models";

export type EntityApiToPathKeys = keyof typeof entityApiPathMappings;

export const isEntityApiPathMapped = (
  entity: RydeUiUnit,
): entity is EntityApiToPathKeys => {
  return entityApiPathMappings[entity as EntityApiToPathKeys] !== undefined;
};

export const entityApiPathMappings: Partial<Record<RydeUiUnit, string>> = {
  addition: "additions",
  adminAction: "adminActions",
  alertConfiguration: "alertConfigurations",
  apiKey: "apiKeys",
  area: "areas",
  areasGroup: "areas-groups",
  auditLog: "auditLogs",
  backup: "backups",
  booking: "bookings",
  businessUnit: "businessUnits",
  busStation: "busStations",
  process: "processes",
  company: "companies",
  complaint: "complaints",
  course: "courses",
  customField: "customFields",
  dataUpload: "dataUploads",
  dayGroup: "dayGroups",
  dayType: "dayTypes",
  disableHour: "disableHours",
  driver: "drivers",
  entity: "entities",
  etlJobLog: "etlJobLogs",
  etlSchedule: "etlSchedules",
  feedback: "feedbacks",
  feedbackSolution: "feedbackSolutions",
  feedbackSubject: "feedbackSubjects",
  fieldType: "fieldTypes",
  flight: "flights",
  foodSupplier: "foodSuppliers",
  formSchema: "formSchemas",
  incident: "incidents",
  incidentType: "incidentTypes",
  globalConfig: "globalConfigs",
  gridSchema: "gridSchemas",
  journey: "journeys",
  language: "languages",
  meal: "meals",
  messagingLog: "messagingLogs",
  notification: "notifications",
  passenger: "passengers",
  passengerSector: "passengers/sector",
  passengerType: "passengerTypes",
  permission: "permissions",
  priceRate: "priceRates",
  produceButton: "produceButtons",
  aiConversation: "aiConversations",
  providerLog: "providerLogs",
  report: "admin/reports/system",
  reason: "reasons",
  reasonCategory: "reasonCategories",
  ride: "rides",
  rideProduction: "rideProductions",
  rideType: "rideTypes",
  role: "global-roles",
  shift: "shifts",
  shiftTemplate: "shiftTemplates",
  site: "sites",
  station: "stations",
  stationDistance: "stationDistances",
  stationRoute: "stationRoutes",
  supplier: "suppliers",
  supplierPriceRate: "supplierPriceRates",
  supplierQuarantine: "supplierQuarantines",
  webhook: "webhooks",
  webhookDelivery: "webhookDeliveries",
  systemManager: "systemManagers",
  systemParam: "systemParams",
  systemTag: "systemTags",
  tracking: "trackings",
  unit: "units",
  user: "users",
  userRole: "userRoles",
  vehicle: "vehicles",
  vehicleType: "vehicleTypes",
  geoArea: "geoAreas",
};
